import React, {PropTypes} from 'react';


function CompanyIcon(props) {
  const {
    className,
    ...otherProps
  } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 20 23" className={`company-icon ${className}`} {...otherProps}>
        <g fill="none" fillRule="evenodd" stroke="#FAFAFA" strokeLinecap="round" strokeLinejoin="round">
            <path strokeWidth="2" d="M8 1h10.667v20H8zM1 8h6.667v13.333H1z"/>
            <path d="M3 12h2v2H3zM3 16h2v2H3zM10 16h2v2h-2zM14 16h2v2h-2zM10 12h2v2h-2zM14 12h2v2h-2zM10 8h2v2h-2zM14 8h2v2h-2zM10 4h2v2h-2zM14 4h2v2h-2z"/>
        </g>
    </svg>
  );
}

CompanyIcon.propTypes = {
  className: PropTypes.string
};

export default CompanyIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/CompanyIcon/index.js